// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_sJr","toggleWrap":"styles_toggleWrap__2cIk6","content":"styles_content__1s5SN","selectAreaCode":"styles_selectAreaCode__2bxlq"};